// extracted by mini-css-extract-plugin
export default {"theeye":"Employees_theeye__R4Isq"};